import React, { Component } from 'react';
import { do_action } from '../../actions'
import {getFloor, convertPrice, formartDate, calculatorPriceItem} from '../../utils/convert'
import PmDuration from './PmDuration'
import DesignerItemQuote from './DesignerItemQuote'
import {BASE_URL_ADMIN} from '../../data/config'

class QuoteDetailItem extends Component {
    constructor(props) {
        super(props)
        this.state = {
            allRoomQuote: [],
            total_price: 0
        }
    }

    componentWillMount() {
        do_action('get_quote_room_item', { quote_id: this.props.quote })
            .then(data => {
                if (data.signal) {
                    let allRoomQuote = data.data
                    let price = 0;
                    allRoomQuote.map((item) => {
                        item.list_items.map((itm) => {
                            price += Number(itm.items.price);
                        });
                    });
                    this.setState({ allRoomQuote, total_price: price });
                }
            })
            .catch(err => console.log(err));
    }

    renderPmItemRoom = (listItem, room_idx) => {
        return listItem.map((it, index) => {
            let urlImage = (it.items.image_path) ? BASE_URL_ADMIN + '/uploads/' + it.items.image_path : '/images/re1.png'
                return (
                    <div className={`mqd-popup clearfix`} key={`items-${index}`}>
                        <div className="pull-left img">
                            <img src={urlImage} alt="" className="img-responsive" />
                        </div>
                        <div className="pull-right">
                            <span className="text-primary-kt price">${it.items.price}</span>
                        </div>
                        <div className="info">
                            <a href="#" className="name">{it.items.title}</a>
                        </div>
                    </div>
                )
        })
    };

    renderQuotesRoomPm = () => {
        let { allRoomQuote } = this.state
        return allRoomQuote.map((roomQuote, idx) => {
            return (
                <div className="block-room" key={`rooms-${idx}`}>
                    <div className="clearfix panen-heading">
                        <div className="pull-left">
                            <div className="big-title">{`${roomQuote.rooms.name} - Floor ${getFloor(roomQuote.floor)}`}</div>
                        </div>
                    </div>
                    <div className="panen-body">
                        {this.renderPmItemRoom(roomQuote.list_items, idx)}
                    </div>
                </div>
            );
        });
    }

    render() {
        return (
            <div>
                {this.renderQuotesRoomPm()}

                {this.props.vendor.type == 'designer' ? (
                    <DesignerItemQuote 
                        {...this.props}
                    />
                ) : (
                    <PmDuration 
                        {...this.props}
                    />
                )}

            </div>
        );
    }
}

export default QuoteDetailItem;